import React, { useState } from 'react';
import classNames from 'classnames';
import styles from './accordion.module.scss';
import { Icon } from '../icon';

export interface AccordionItemProps {
  title: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  disabled?: boolean;
  className?: string;
}

export const AccordionItem: React.FC<AccordionItemProps> = ({
  title,
  children,
  defaultOpen = false,
  disabled = false,
  className
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={classNames(styles.item, className, {
      [styles.isOpen]: open,
      [styles.isDisabled]: disabled
    })}>
      <div 
        className={styles.header}
        onClick={() => !disabled && setOpen(!open)}
      >
        <span>{title}</span>
        <Icon name="angle-down" className={styles.icon} />
      </div>
      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
};

export interface AccordionProps {
  children: React.ReactNode;
  className?: string;
}

export const Accordion: React.FC<AccordionProps> = ({ children, className }) => {
  return (
    <div className={classNames(className)}>
      {children}
    </div>
  );
};
